import { setBasePlateOptions } from "../dimension/actions";

export const SET_EDITOR_VERTICES_TYPE = 'SET_EDITOR_VERTICES_TYPE';
export const SET_EDITOR_ANCHORS_TYPE = 'SET_EDITOR_ANCHORS_TYPE';
export const SET_EDITOR_STATE = 'SET_EDITOR_STATE';
export const RESET_EDITOR_STATE = 'RESET_EDITOR_STATE';

/*
  Action creators
 */
export function resetEditorState() {
  return { type: RESET_EDITOR_STATE };
}
export function setEditorState(state) {
  return { type: SET_EDITOR_STATE, state };
}

export function setEditorVerticesType(value = null) {
  return { type: SET_EDITOR_VERTICES_TYPE, value };
}

export function setEditorAnchorsType(value = null) {
  return { type: SET_EDITOR_ANCHORS_TYPE, value };
}

export function setEditorCustomCoordinates(panelCoords, screwCoords) {
  return (dispatch) => {
    dispatch(setBasePlateOptions({
      editor: {
        panelCoordinates: panelCoords,
        screwCoordinates: screwCoords
      }
    }));
  };
}



// WEBPACK FOOTER //
// ./src/reducers/selectors/editor/actions.js